import { Confirmation } from 'primeng/api';

export const CONFIRM_POPUP_CONFIG: Confirmation = {
	header: 'Confirmation',
	message: 'Are you sure you want to proceed?',
	icon: 'pi pi-exclamation-triangle',
	acceptLabel: 'Yes',
	rejectLabel: 'No',
	acceptButtonProps: {
		label: 'Yes',
		outlined: false
	},
	rejectButtonProps: {
		label: 'No',
		severity: 'secondary',
		outlined: false
	},
	acceptButtonStyleClass: '!px-8',
	rejectButtonStyleClass: '!px-8'
};

export const TOOLBAR_CONFIG = {
	styleClass: '!px-8 !bg-gray-50 !border-transparent !rounded-none'
};

export const DEFAULT_PAGINATED_REQUEST = {
	page: 0,
	size: 10,
	hasNextPage: true,
	loading: false
};
